import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/bottle-in-box.png'
import _imports_1 from '../images/clap-inbox.png'
import _imports_2 from '../images/everyone-boxmoving-1.png'
import _imports_3 from '../images/campus-boxmoving-1.png'
import _imports_4 from '../images/everyone-boxmoving-2.png'
import _imports_5 from '../images/campus-boxmoving-2.png'


const _withScopeId = n => (_pushScopeId("data-v-3656f84e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-wrapper d-none d-sm-block" }
const _hoisted_2 = { class: "line-box d-inline-flex font-Pretendar fw-bold gap-3 w-100 justify-content-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-item",
  style: {"width":"10rem"}
}, null, -1))
const _hoisted_4 = {
  class: "box-item bg-cola triangle text-14",
  style: {"width":"15rem"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-item bg-yellow",
  style: {"width":"8rem"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "bottle-inbox",
    src: _imports_0
  })
], -1))
const _hoisted_6 = {
  class: "box-item bg-white triangle right",
  style: {"width":"15rem"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-item",
  style: {"width":"20rem"}
}, null, -1))
const _hoisted_8 = { class: "line-box slide-right d-inline-flex font-Pretendar fw-bold gap-3 mt-5 w-100 justify-content-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-item",
  style: {"width":"20rem"}
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-item bg-yellow",
  style: {"width":"8rem"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "clap-inbox",
    src: _imports_1
  })
], -1))
const _hoisted_11 = {
  class: "box-item bg-white triangle right",
  style: {"width":"10rem"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-item bg-yellow",
  style: {"width":"8rem"}
}, null, -1))
const _hoisted_13 = {
  class: "box-item bg-cola triangle",
  style: {"width":"15rem"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-item",
  style: {"width":"15rem"}
}, null, -1))
const _hoisted_15 = { class: "d-sm-none my-5 overflow-hidden" }
const _hoisted_16 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "mobile-line"
}
const _hoisted_17 = {
  key: 1,
  src: _imports_3,
  alt: "",
  class: "mobile-line"
}
const _hoisted_18 = {
  key: 0,
  src: _imports_4,
  alt: "",
  class: "mobile-line slide-right"
}
const _hoisted_19 = {
  key: 1,
  src: _imports_5,
  alt: "",
  class: "mobile-line slide-right"
}

interface Props {
  text1?: string
  text2?: string
  text3?: string
  text4?: string
  challengeType?: 'everyone' | 'campus'
}


export default /*#__PURE__*/_defineComponent({
  props: {
    text1: { default: '모두의 챌린지는' },
    text2: { default: '남녀노소 누구나' },
    text3: { default: '쉽게' },
    text4: { default: '참여가능' },
    challengeType: { default: 'everyone' }
  },
  setup(__props: any) {

const props = __props as { text1: string, text2: string, text3: string, text4: string, challengeType: 'everyone' | 'campus' }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.text1), 1),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(props.text2), 1),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(props.text3), 1),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, _toDisplayString(props.text4), 1),
        _hoisted_14
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", null, [
        (__props.challengeType==='everyone')
          ? (_openBlock(), _createElementBlock("img", _hoisted_16))
          : _createCommentVNode("", true),
        (__props.challengeType==='campus')
          ? (_openBlock(), _createElementBlock("img", _hoisted_17))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (__props.challengeType==='everyone')
          ? (_openBlock(), _createElementBlock("img", _hoisted_18))
          : _createCommentVNode("", true),
        (__props.challengeType==='campus')
          ? (_openBlock(), _createElementBlock("img", _hoisted_19))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})